export type CardVariant = 'red' | 'blue';

export type CardModuloConfig = {
  /** bate por id do módulo (se existir) */
  id?: string | number;

  /** bate por caminho (recomendado) ex: "/empresas" */
  caminho?: string;

  /** bate por nome (fallback) */
  nome?: string;

  /** texto que aparece no card */
  texto: string;

  /** se quiser forçar a cor; se não, usa o hash (determinístico) */
  variant?: CardVariant;
};

export const CARDS_MODULOS_CONFIG: CardModuloConfig[] = [
  {
    caminho: '/empresas',
    texto: 'aaaaaaaaaaaaaaaaaa.',
    variant: 'blue',
  },
  {
    caminho: '/relatorios',
    texto: 'bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb.',
    variant: 'red',
  },
//   {
//     nome: 'Financeiro',
//     texto: 'ccccccccccccccccccccccccccccccccc',
//   },
];

export const CARD_TEXTO_PADRAO = 'modulo novo sem estrutura no front AINDA.';

export const CARD_DEFAULT_VARIANT: CardVariant = 'blue';
